import { useState, useEffect } from "react"
import { useParams, Link } from "react-router-dom"
import { ApiKey } from "../../config/APIKey"
import { Container } from "./style"

function Details(){
    const [movie, setMovie] = useState({})
    const {id} = useParams()
    const image_path = 'https://image.tmdb.org/t/p/w500/'


    useEffect(() => {
        fetch(`https://api.themoviedb.org/3/movie/${id}?api_key=${ApiKey}&language=pt-BR`)
        .then(response => response.json())
        .then(data => {
        const movie = {
            id,
            title: data.title,
            sinopse: data.overview,
            image: `${image_path}${data.poster_path}`,
            releaseDate: data.release_date
        }
        setMovie(movie)
       })
    }, [id])
    return(
        <Container>
            <div className="movie">
                <img src={movie.image} alt={movie.sinopse} />
                <div className="details">
                   <h1>{movie.title}</h1>
                   <span>Sinopse: {movie.sinopse}</span> 
                    <span className="dataLancamento">Data de Lançamento: {movie.releaseDate}</span>
                    <Link to={'/'}><button>Voltar</button></Link>
                </div>
            </div>
        </Container>
    )
}
export default Details